import { render } from "./GlBadge.vue?vue&type=template&id=162ca014&scoped=true"
import script from "./GlBadge.vue?vue&type=script&lang=js"
export * from "./GlBadge.vue?vue&type=script&lang=js"

import "./GlBadge.vue?vue&type=style&index=0&id=162ca014&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-162ca014"

export default script